import { jsxs, jsx } from 'react/jsx-runtime';
import { ErrorMessage } from '@promo-platform/error-message';
import { FieldHead } from '@promo-platform/field-head';
import { useFormContext } from 'react-hook-form';
var RadioListItem = function RadioListItem(_ref) {
  var label = _ref.label,
    value = _ref.value,
    groupAlias = _ref.groupAlias,
    isRequired = _ref.isRequired,
    isSelected = _ref.isSelected;
  var _useFormContext = useFormContext(),
    register = _useFormContext.register;
  return jsxs("div", Object.assign({
    className: "pp-radio-list-item"
  }, {
    children: [jsx("input", Object.assign({}, register(groupAlias, {
      required: isRequired && isRequired.errorMessage
    }), {
      id: value,
      type: "radio",
      value: value,
      defaultChecked: isSelected
    })), jsx("label", Object.assign({
      htmlFor: value
    }, {
      children: label
    }))]
  }));
};
var RadioList = function RadioList(_ref2) {
  var alias = _ref2.alias,
    id = _ref2.id,
    label = _ref2.label,
    description = _ref2.description,
    tooltip = _ref2.tooltip,
    tooltipLabel = _ref2.tooltipLabel,
    options = _ref2.options,
    minNumberOfAnswersValidation = _ref2.minNumberOfAnswersValidation;
  var _a;
  var _useFormContext2 = useFormContext(),
    errors = _useFormContext2.formState.errors;
  return jsxs("div", Object.assign({
    className: "pp-radio-list"
  }, {
    children: [jsx(FieldHead, {
      id: id,
      label: label,
      description: description,
      tooltipText: tooltip,
      tooltipLabel: tooltipLabel
    }), jsx("div", Object.assign({
      className: "pp-radio-list__items"
    }, {
      children: options.map(function (item) {
        return jsx(RadioListItem, {
          groupAlias: alias,
          label: item.label,
          value: item.value,
          isSelected: item.isSelected,
          isRequired: minNumberOfAnswersValidation
        }, item.value);
      })
    })), jsx(ErrorMessage, {
      message: (_a = errors[alias]) === null || _a === void 0 ? void 0 : _a.message
    })]
  }));
};
export { RadioList };